import { boundaryFilter, propertyFilter } from "./projectscope";
import { fetchDataAsGeoJSON, fetchAllDataAsGeoJSON } from "./util";
export class LidarProvider {
    constructor(apiHost, authObject, projectScope, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
        this._projectScope = projectScope;
    }
    allLidarFragments(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("fragment", {
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/fragments/${collection}/query?fields=uid,campaign_name,start_timestamp&limit=2000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    allLidarFragmentLines(loa, collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("routeLines", {
                properties: [{ key: "loa", operator: "eq", value: loa.toString() }],
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/fragmentLines/${collection}/query?limit=2000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    allLidarFragmentHexes(loa, collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("routeLines", {
                properties: [{ key: "loa", operator: "eq", value: loa.toString() }],
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/fragmentHexes/${collection}/query?limit=2000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    orderLidarFragments(collection, email, user_uid, fragments_uids, onSuccess, onError) {
        const url = `${this._apiHost.href}/orders/${collection}`;
        fetch(url, {
            method: "POST",
            headers: {
                "content-type": "application/x-www-form-urlencoded",
                "x-api-key": this._authObject.apiKey,
                Authorization: `Bearer ${this._authObject.accessToken}`,
            },
            body: JSON.stringify({
                email: email,
                user_uid: user_uid,
                fragment_uids: fragments_uids,
            }),
        })
            .then((resp) => {
            if (resp.ok) {
                onSuccess(resp);
            }
            else {
                throw new Error("Error in placing the order.");
            }
        })
            .catch(onError);
    }
    set authObject(authObject) {
        this._authObject = authObject;
    }
}
//# sourceMappingURL=lidarprovider.js.map